const intialState = {
  jobDetails: {} as any,
  loading: false,
  error: null
};

const jobDetailsReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case 'GET_JOB_DETAIL_REQUEST':
      return {
        ...state,
        loading: true
      };
    case 'GET_JOB_DETAIL_SUCCESS':
      return {
        ...state,
        loading: false,
        jobDetails: action.payload.data
      };
    case 'GET_JOB_DETAIL_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload.message
      };
    case 'CLEAR_JOB_DETAIL':
      return {
        ...intialState
      };
    default:
      return state;
  }
};

export default jobDetailsReducer;
